document.addEventListener('DOMContentLoaded', function () {
    let chatbot = document.getElementById('spr-live-chat-app');
    const chatTriggers = document.querySelectorAll('.chat-trigger');

    const handleChatbotVisibility = () => {
        if (chatbot) chatbot.classList.add('is-hidden');
    };

    const updateChatTriggerButtons = (isOpen) => {
        document.querySelectorAll('.chat-trigger').forEach(trigger => {
            const label = trigger.querySelector('.chat-trigger__label');
            const icon = trigger.querySelector('.fa-solid');

            if (isOpen) {
                if (label && label.dataset.chatCloseLabel) label.textContent = label.dataset.chatCloseLabel;
                if (icon) {
                    icon.classList.remove('fa-comments');
                    icon.classList.add('fa-times', 'fa-lg', 'mt-1');
                }
            }
            else {
                if (label && label.dataset.chatOpenLabel) label.textContent = label.dataset.chatOpenLabel;
                if (icon) {
                    icon.classList.remove('fa-times', 'fa-lg', 'mt-1');
                    icon.classList.add('fa-comments');
                }
            }
        });
    };

    const handleChatTriggerClick = ({ close = true } = {}) => {
        const chatBox = document.querySelector('.spr-chat__box');

        if (chatBox) {
            if (close) window.sprChat('close');
            updateChatTriggerButtons(false);
            if (chatbot) chatbot.classList.add('is-hidden');
        }
        else {
            window.sprChat('open');
            updateChatTriggerButtons(true);
            if (chatbot) chatbot.classList.remove('is-hidden');
        }
    };

    if (chatbot) {
        handleChatbotVisibility();
    }
    else {
        const chatbotObserver = new MutationObserver((mutationsList, observer) => {
            chatbot = document.getElementById('spr-live-chat-app');
            if (chatbot) {
                handleChatbotVisibility();
                observer.disconnect();
            }
        });

        chatbotObserver.observe(document.body, { childList: true, subtree: true });
    }

    chatTriggers.forEach(trigger => {
        trigger.addEventListener('click', handleChatTriggerClick);
    });

    const triggerButtonObserver = new MutationObserver(mutationsList => {
        mutationsList.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) {
                    const triggerButton = node.id === 'spr-chat__trigger-button' ? node : node.querySelector('#spr-chat__trigger-button');
                    if (triggerButton) {
                        triggerButton.addEventListener('click', () => {
                            handleChatTriggerClick({ close: false })
                        });
                    }
                }
            });
        });
    });

    triggerButtonObserver.observe(document.body, { childList: true, subtree: true });
});
